module.exports = {
	extends: [
		'/',
		'base',
		'mediaManagement',
		'mediaDetailsSummary'
	],

	config: {
		isEnhanced: true
	},

	methods: {
		dataDealer: function(){
			this.model.media = this.getResourceRegisterContent('enhanced');
		}
	}
};